import React from 'react';
import {Typography,Grid} from '@material-ui/core';
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
function Kontkat(props) {
    return (
        <>
        {
            isUndefined(props.Kontkat)?""
            :
<Grid container className="px-5">
            <Grid md="12">
            <h2>Kontkat</h2>
            </Grid>      
            <Grid md="2"><Typography>Namn:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Kontkat.fname}</Typography></Grid>          
            <Grid md="2"><Typography>Förrnamn:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Kontkat.lname}</Typography></Grid>          
            <Grid md="2"><Typography><IntlMessages id="E-mail"/>: </Typography></Grid>      
            <Grid md="10"><Typography>{props.Kontkat.Email}</Typography></Grid>          
            <Grid md="2"><Typography><IntlMessages id="Tele"/>:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Kontkat.Tele}</Typography></Grid>          
            <Grid md="2"><Typography>Role:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Kontkat.Role}</Typography></Grid>          
        </Grid>
        }
        
        </>
    );
}

export default Kontkat;